"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.CategoryWrap = styled_components_1.default.div `
  display: flex;
  width: 100%;
  gap: 16px;

    &.speech {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 15px;
        @media screen and (max-width: 610px) {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
        }
    }
    
  &.framed {
    display: grid;
    grid-template-columns: repeat(4, 4fr);
    justify-content: space-between;

    & > details[open] {
      grid-column: span 4 / span 4;
    }

    & > details > summary {
      justify-content: center;
    }

    & > details {
      padding: 32px 16px;

      @media screen and (min-width: 768px) {
        padding: 32px;
      }

      @media screen and (min-width: 1920px) {
        padding: 35px 32px;
      }
    }

    & > details[open] > summary {
      justify-content: flex-start;
    }
  }

  &.default {
    flex-direction: column;
  }

  @media screen and (min-width: 1000px) {
    gap: 24px;
  }

  @media screen and (min-width: 1920px) {
    gap: 32px;
  }
`;
